import React from 'react';
import AboutMe from '../AboutMe/AboutMe';
import ContactInfo from '../Contact/ContactInfo/ContactInfo';
import Navbar from '../Navbar/Navbar';
import ContactPageForm from './ContactForm/ContactPageForm';

const ContactPage = () => {
    return (
        <div>
            <Navbar />
            {/* <ContactInfo /> */}
            <AboutMe />
            <ContactPageForm />
        </div>
    );
};

export default ContactPage;